import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Item, Segment } from 'semantic-ui-react'
import ArduinoStore from '../../../app/stores/arduinoStore'
import ArduinoValueDisplay from './ArduinoValueDisplay'

interface Props {
  arduinoStore: ArduinoStore;
}
export default function ArduinoList ({ arduinoStore }: Props) {
  // const {arduinoStore} = useStore();
  const { deleteArduino, arduinos, loading } = arduinoStore
  const [target, setTarget] = useState('')

  function handleArduinoDelete (e: any, id: string) {
    setTarget(e.target.name)
    deleteArduino(id)
  }

  return (
    <Segment>
      <Item.Group divided>
        {arduinos.map((arduino:any) => (
          <Item key={arduino.id}>
            <Item.Content>
              <Item.Header as="a">Internet of Things</Item.Header>
              <Item.Meta>{/* {arduino.id} */}</Item.Meta>
              <Item.Description>
                <ArduinoValueDisplay arduinos={arduinos} arduinoId={arduino.id}>{arduino.value}</ArduinoValueDisplay>
              </Item.Description>
              <Item.Extra>
                <Button
                  as={Link}
                  to={`/arduinos/${arduino.id}`}
                  floated="left"
                  content="View"
                  color="blue"
                />
                <Button
                  name={arduino.id}
                  loading={loading && target === arduino.id}
                  onClick={(e) => handleArduinoDelete(e, arduino.id)}
                  floated="right"
                  content="Delete"
                  color="red"
                />
                {/* <Label basic content={arduino.category} /> */}
              </Item.Extra>
            </Item.Content>
          </Item>
        ))}
      </Item.Group>
    </Segment>
  )
}
